function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.14282 4.71484C1.93368 4.71484 0.142822 6.50571 0.142822 8.71485V46.2863C0.142822 48.4954 1.93369 50.2863 4.14283 50.2863H33.8571C36.0662 50.2863 37.8571 48.4954 37.8571 46.2863V8.71484C37.8571 6.5057 36.0662 4.71484 33.8571 4.71484H4.14282ZM11.9285 15.7151C10.6267 15.7151 9.57133 16.7705 9.57133 18.0723C9.57133 19.3741 10.6267 20.4294 11.9285 20.4294H18.2142C19.516 20.4294 20.5713 19.3741 20.5713 18.0723C20.5713 16.7705 19.516 15.7151 18.2142 15.7151H11.9285ZM9.57133 27.5007C9.57133 26.1989 10.6267 25.1436 11.9285 25.1436H26.0713C27.3731 25.1436 28.4285 26.1989 28.4285 27.5007C28.4285 28.8025 27.3731 29.8578 26.0713 29.8578H11.9285C10.6267 29.8578 9.57133 28.8025 9.57133 27.5007ZM11.9285 34.572C10.6267 34.572 9.57133 35.6273 9.57133 36.9291C9.57133 38.2309 10.6267 39.2863 11.9285 39.2863H26.0713C27.3731 39.2863 28.4285 38.2309 28.4285 36.9291C28.4285 35.6273 27.3731 34.572 26.0713 34.572H11.9285Z",
  fill: "#EF5DA8"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 6.42847,
  width: 23.5714,
  height: 9.42857,
  rx: 4,
  fill: "#74D6D6"
});
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 51,
    viewBox: "0 0 38 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.0029b725.svg";
export { ForwardRef as ReactComponent };